
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Newspaper } from "lucide-react";

export const NewsMonitoringDisabled = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Newspaper className="h-5 w-5" />
          News Intelligence
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-center py-8">
          <Newspaper className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
          <p className="text-lg font-medium mb-2">News monitoring is disabled</p>
          <p className="text-sm text-muted-foreground">
            Enable news monitoring in the client settings to start receiving news alerts.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
